export default __webpack_public_path__ + "static/media/writingtablet.805a04fc.png";